import { PRODUCT_TYPE } from '@ahmdigital/constants';

import { BuildYourCoverProductType } from '../../../../actions/build-your-cover';

const { EXTRAS, HOSPITAL } = PRODUCT_TYPE;

const getCarouselTypeOrder = (addOnType: BuildYourCoverProductType | null): BuildYourCoverProductType[] => {
  if (addOnType === HOSPITAL) return [EXTRAS, HOSPITAL];
  return [HOSPITAL, EXTRAS];
};

export default getCarouselTypeOrder;
